import { extractExcerpt, replaceTags, sanitizeHtml } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { IScript } from './Script.interface';

export default class Script extends Root implements IScript {
  name: string;
  content: string;

  getName() {
    return this.name;
  }

  getExcerpt() {
    return extractExcerpt(replaceTags(this.getContent(), ' '));
  }

  getContent() {
    return this.content;
  }

  static build = (data: IScript) => new Script(data);
  static blank = () => new Script({ isActive: true });

  /**
   * Constructor
   * @param {IScript} data
   */
  constructor(data?: IScript) {
    super(DocType.of('__definition.script'), data);

    this.name = data?.name || '';
    this.content = sanitizeHtml(data?.content || '');
  }
}
